module.exports = __webpack_public_path__ + "img/bckarrow.b073ab91.svg";